
export default function Team() {
  return (
    <section id="team" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
            Nossa Equipe
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Profissionais de alta performance com resultados comprovados no mercado
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-slate-50 rounded-xl p-8">
            <div className="flex items-start space-x-4 mb-4">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-trophy-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-800 mb-2">Alta Performance</h3>
                <p className="text-slate-600 leading-relaxed">
                  Buscamos equipes de alta performance com skills e resultados comprovados no mercado específicos para as empresas investidas e projetos onde estamos.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 rounded-xl p-8">
            <div className="flex items-start space-x-4 mb-4">
              <div className="w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-lightbulb-flash-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-800 mb-2">Espírito Inovador</h3>
                <p className="text-slate-600 leading-relaxed">
                  Espírito inovador atrelado ao conhecimento são características fundamentais para fazer parte de nossa rede de associados.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-slate-800 via-slate-900 to-teal-900 rounded-2xl overflow-hidden shadow-2xl relative">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
          </div>
          
          <div className="relative z-10 p-12">
            <div className="max-w-4xl mx-auto">
              <div className="mb-8">
                <span className="inline-block px-4 py-2 bg-teal-600 text-white text-sm font-semibold rounded-full mb-4">
                  Sócio Fundador
                </span>
                <h3 className="text-4xl font-bold text-white mb-2">Ricardo Manhães</h3>
              </div>
              
              <p className="text-slate-300 leading-relaxed mb-8 text-lg">
                Fundador da Selem&Selem Participações com objetivo de empreender como sócio fundador da Netpoints Fidelidade S.A.
              </p>
              
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                  <div className="flex items-start space-x-3">
                    <div className="w-10 h-10 bg-teal-600/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-briefcase-line text-teal-400 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-white font-semibold mb-2">Experiência Profissional</h4>
                      <p className="text-slate-300 text-sm leading-relaxed">
                        Banco Itaú-Unibanco, Tempo Assist, Fininvest Administradora de Cartões, Losango Financeira, Banco Nacional e Audi-Market
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                  <div className="flex items-start space-x-3">
                    <div className="w-10 h-10 bg-teal-600/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-graduation-cap-line text-teal-400 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-white font-semibold mb-2">Formação Acadêmica</h4>
                      <p className="text-slate-300 text-sm leading-relaxed">
                        Engenharia FTESM-RJ • Análise de Sistemas PUC-RJ • MBA Executivo COPPEAD-UFRJ
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex space-x-4">
                <a href="https://www.linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-all cursor-pointer border border-white/20">
                  <i className="ri-linkedin-fill text-white text-xl"></i>
                </a>
                <a href="mailto:contato@selemselem.com.br" className="w-12 h-12 bg-white/10 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-all cursor-pointer border border-white/20">
                  <i className="ri-mail-line text-white text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-slate-600 text-lg leading-relaxed max-w-3xl mx-auto">
            Hoje a Selem&Selem Participações possui uma <strong>rede de associados</strong> que são responsáveis pelo sucesso das empresas investidas e pela condução dos projetos de consultoria estratégica e mentoring.
          </p>
        </div>
      </div>
    </section>
  );
}
